import { mytDayTime } from '../../utils/mytTime.js';

/** 408 (#1434): the fuel a car carries on `GET /cars`, `GET /cars/:id` and a booking's `car` (contracts/api.md). */
export interface CarFuel {
  percent: number;
  read_at: string | null;
  bars_total: number;
  bars_filled: number;
}

/**
 * 408 (mock-up screens 1–3): the car's fuel as bars on its own gauge (the platform decides how many are full, the
 * way the dashboard shows them), the percentage beside, and when Cartrack read it (spec FR-002: always). Renders nothing
 * when the car carries no fuel (not on Cartrack, or no reading).
 */
export function FuelGauge({
  fuel,
  size = 'small',
}: { fuel?: CarFuel | null; size?: 'small' | 'large' }) {
  if (!fuel) return null;
  const words = `Fuel ${fuel.bars_filled} of ${fuel.bars_total} bars`;
  const large = size === 'large';
  return (
    <div data-testid="fuel-gauge" className="flex flex-wrap items-center gap-2 text-xs">
      <div
        role="img"
        aria-label={`${words}, ${fuel.percent}%`}
        className={`flex ${large ? 'gap-[3px]' : 'gap-0.5'}`}
      >
        {Array.from({ length: fuel.bars_total }, (_, i) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: the bars are positions on a fixed gauge
            key={i}
            data-bar={i < fuel.bars_filled ? 'on' : 'off'}
            className={`rounded-sm ${large ? 'h-[18px] w-3.5' : 'h-3 w-2'} ${i < fuel.bars_filled ? 'bg-primary' : 'bg-border'}`}
          />
        ))}
      </div>
      <div>
        <span className="font-semibold text-text">{words}</span>{' '}
        <span className="text-text-muted">· {fuel.percent}%</span>
        {fuel.read_at && (
          <div className="text-[11px] text-text-muted">as of {mytDayTime(fuel.read_at)}</div>
        )}
      </div>
    </div>
  );
}
